import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetTournamentDetails } from "../../api-clients/tournamentsClient";

function useGetTournamentDetailsQuery({
  tournamentId,
  enabled = true,
}: {
  tournamentId: string;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.TOURNAMENT_DETAILS],
    queryFn: () => handleGetTournamentDetails(tournamentId),
    enabled: enabled && !!tournamentId,
  });

  return query;
}

export default useGetTournamentDetailsQuery;
